import OrganisationsSearchPage from "@/components/organisation/OrganisationsSearchPage";

export default [
  {
    path: "/organisations",
    component: {
      render(h) {
        return h("router-view");
      }
    },
    meta: { breadcrumbI18n: "navigation:breadcrumbs.organisations.title" },
    children: [
      {
        path: "",
        name: "OrganisationsSearchPage",
        meta: {
          keepAlive: true,
          anchor: "#jumpMobile"
        },
        component: OrganisationsSearchPage
      },
      {
        path: "new",
        name: "OrganisationCreationPage",
        component: () => import("@/components/organisation/OrganisationForm"),
        meta: {
          breadcrumb: "New",
          requireAuthorize: true,
          anchor: "#jumpBreadcrumb"
        }
      },
      {
        path: ":organisationId",
        name: "OrganisationRoot",
        component: {
          render(h) {
            return h("router-view");
          }
        },
        props: true,
        redirect: { name: "OrganisationProfilePage" },
        meta: { breadcrumb: { breadcrumbName: "organisationName" } },
        children: [
          {
            path: "",
            name: "OrganisationProfilePage",
            component: () =>
              import("@/components/organisation/OrganisationProfilePage"),
            props: true,
            meta: { breadcrumb: "Profile", anchor: "#jumpBreadcrumb" }
          },
          {
            path: "edit",
            name: "OrganisationEditPage",
            component: () =>
              import("@/components/organisation/OrganisationForm"),
            props: true,
            meta: {
              breadcrumb: "Edit",
              requireAuthorize: true,
              anchor: "#jumpBreadcrumb"
            }
          }
        ]
      }
    ]
  }
];
